const tenant_management_en = {
  edit_tenant_info:'edit tenant information',
  empty_name:'Please enter tenant name',
  empty_code:'Please enter tenant code'
}

export default tenant_management_en



// WEBPACK FOOTER //
// ./src/common/lang/tenant_management/tenant_management_en.js